import React from "react";
import Service from "../Components/Service";
import SectionIntro from "../Components/SectionIntro";

const ServicesWoman: React.FC = () => {
  return(
    <div className="bg-primaryWoman pt-12 2xl:pt-20 pb-16">
      <SectionIntro
        eyebrow="Per lei"
        title={<>Benvenuta nel futuro del benessere femminile.<br/>Innovazione unica nel suo genere.</>}
        titleColor="text-accentWoman"
      >
        <p className="max-w-[300px] 2xl:max-w-[420px] mx-auto mt-5 text-base leading-[1.7] text-white/[.92]">
          Attraverso i nostri percorsi emozionali ogni tuo desiderio diventa realtà.<br/>
          Semplice, immediato e senza pensieri.<br/>
          Tutto è incluso.
        </p>
        <blockquote className="max-w-[300px] 2xl:max-w-[420px] mx-auto mt-7">
          <p className="font-serif italic text-[21px] leading-[1.35] text-white">Dove le parole non arrivano… La musica parla.</p>
          <cite className="block mt-2.5 not-italic text-3xs font-medium tracking-[.24em] uppercase text-white/60">Ludwig van Beethoven</cite>
        </blockquote>
      </SectionIntro>
      <ul className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-x-10 max-w-[1400px] mx-auto px-8 pt-4">
        <Service icon="bg-service-scissors" header="Assolo" headerTextColor={"accentWoman"} text="Rituale purificante & piega"/>
        <Service icon="bg-service-razor" header="Armonia" headerTextColor={"accentWoman"} text="Rituale purificante, taglio & piega"/>
        <Service icon="bg-service-scissors" header="Accordo Minore" headerTextColor={"accentWoman"} text="Rituale colore di base, gloss & piega"/>
        <Service icon="bg-service-razor" header="Accordo Maggiore" headerTextColor={"accentWoman"} text="Rituale colore di base, gloss, taglio & piega"/>
        <Service icon="bg-service-scissors" header="Sinfonia Breve" headerTextColor={"accentWoman"} text="Rituale schiariture, gloss & piega"/>
        <Service icon="bg-service-razor" header="Sinfonia Estesa" headerTextColor={"accentWoman"} text="Rituale schiariture, gloss, taglio & piega"/>
        <Service icon="bg-service-scissors" header="Sinfonia Estesa Plus" headerTextColor={"accentWoman"} text="Rituale schiariture, colore, gloss, taglio & piega"/>
        <Service icon="bg-service-razor" header="Opera Prima" headerTextColor={"accentWoman"} text="Rituale schiariture complesse (cartine hairtouch), gloss, taglio & piega"/>
      </ul>
    </div>
  )
};

export default ServicesWoman;
